<template>
  <v-list
    v-if="
      showOnMobile || !$vuetify.breakpoint.mobile || $vuetify.breakpoint.mdAndUp
    "
    class="py-0"
    color="transparent"
    :class="{ 'mb-2': $vuetify.breakpoint.mobile }"
  >
    <v-breadcrumbs
      v-if="
        breadcrumbs && ($vuetify.breakpoint.mdAndUp || showBreadcrumbsOnMobile)
      "
      class="pa-0"
      :items="breadcrumbs"
      divider="/"
    ></v-breadcrumbs>
    <v-list-item class="px-0">
      <v-list-item-avatar color="primary" @click="$emit('clickIcon')">
        <v-icon dark>{{ icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline primary--text font-weight-bold">
          <v-chip
            v-if="showFolowing"
            depressed
            color="transparent"
            hide-details
            class="pl-0 pr-0"
            :noClickAnimation="true"
            @click="toggelFollowing"
          >
            <v-icon v-if="isFollowed" color="success">mdi-star</v-icon>
            <v-icon v-else color="grey">mdi-star-outline</v-icon>
          </v-chip>

          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="subtitle">
          {{ subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action class="justify-end">
        <slot name="headlineBtns"></slot>
      </v-list-item-action>
    </v-list-item>
    <v-divider class="mb-4" v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
  </v-list>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseHeadline",
  props: {
    showOnMobile: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    headerName: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    breadcrumbs: {
      type: Array,
      default: null,
    },
    showBreadcrumbsOnMobile: {
      type: Boolean,
      default: false,
    },
    showFolowing: {
      type: Boolean,
      default: false,
    },
    isFollowed: {
      type: Boolean,
      default: false,
    },
    enableFollowing: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    title(): string {
      if (this.headerName) {
        return this.headerName;
      }
      return this.$route.meta?.headerName;
    },
  },
  methods: {
    toggelFollowing() {
      if (!this.enableFollowing) return;
      this.$emit("toggelFollowing");
    },
  },
});
</script>
